/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getNurses } from 'app/entities/nurse/nurse.reducer';
import { getEntities as getShifts } from 'app/entities/shift/shift.reducer';
import { getEntities as getDepartments } from 'app/entities/department/department.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { getEntities as getWards } from 'app/entities/ward/ward.reducer';
import { createEntity, getEntity, reset, updateEntity } from './schedule.reducer';

export const ScheduleUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const nurses = useAppSelector(state => state.nurse.entities);
  const shifts = useAppSelector(state => state.shift.entities);
  const departments = useAppSelector(state => state.department.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const wards = useAppSelector(state => state.ward.entities);
  const scheduleEntity = useAppSelector(state => state.schedule.entity);
  const loading = useAppSelector(state => state.schedule.loading);
  const updating = useAppSelector(state => state.schedule.updating);
  const updateSuccess = useAppSelector(state => state.schedule.updateSuccess);

  const handleClose = () => {
    navigate(`/schedule${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getNurses({}));
    dispatch(getShifts({}));
    dispatch(getDepartments({}));
    dispatch(getHospitals({}));
    dispatch(getWards({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.scheduleDate !== undefined && typeof values.scheduleDate !== 'number') {
      values.scheduleDate = Number(values.scheduleDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdate !== undefined && typeof values.lastUpdate !== 'number') {
      values.lastUpdate = Number(values.lastUpdate);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.hoursServed !== undefined && typeof values.hoursServed !== 'number') {
      values.hoursServed = Number(values.hoursServed);
    }

    const entity = {
      ...scheduleEntity,
      ...values,
      nurse: nurses.find(it => it.id.toString() === values.nurse?.toString()),
      shift: shifts.find(it => it.id.toString() === values.shift?.toString()),
      department: departments.find(it => it.id.toString() === values.department?.toString()),
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
      ward: wards.find(it => it.id.toString() === values.ward?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...scheduleEntity,
          nurse: scheduleEntity?.nurse?.id,
          shift: scheduleEntity?.shift?.id,
          department: scheduleEntity?.department?.id,
          hospital: scheduleEntity?.hospital?.id,
          ward: scheduleEntity?.ward?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.schedule.home.createOrEditLabel" data-cy="ScheduleCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.schedule.home.createOrEditLabel">Create or edit a Schedule</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="schedule-id"
                  label={translate('tinyMedicRestApp.schedule.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.schedule.scheduleDate')}
                id="schedule-scheduleDate"
                name="scheduleDate"
                data-cy="scheduleDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.schedule.active')}
                id="schedule-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.schedule.cursor')}
                id="schedule-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.schedule.lastUpdate')}
                id="schedule-lastUpdate"
                name="lastUpdate"
                data-cy="lastUpdate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.schedule.microSec')}
                id="schedule-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.schedule.timestampEntry')}
                id="schedule-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.schedule.served')}
                id="schedule-served"
                name="served"
                data-cy="served"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.schedule.hoursServed')}
                id="schedule-hoursServed"
                name="hoursServed"
                data-cy="hoursServed"
                type="text"
              />
              <ValidatedField
                id="schedule-nurse"
                name="nurse"
                data-cy="nurse"
                label={translate('tinyMedicRestApp.schedule.nurse')}
                type="select"
              >
                <option value="" key="0" />
                {nurses
                  ? nurses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="schedule-shift"
                name="shift"
                data-cy="shift"
                label={translate('tinyMedicRestApp.schedule.shift')}
                type="select"
              >
                <option value="" key="0" />
                {shifts
                  ? shifts.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="schedule-department"
                name="department"
                data-cy="department"
                label={translate('tinyMedicRestApp.schedule.department')}
                type="select"
              >
                <option value="" key="0" />
                {departments
                  ? departments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="schedule-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.schedule.hospital')}
                type="select"
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="schedule-ward"
                name="ward"
                data-cy="ward"
                label={translate('tinyMedicRestApp.schedule.ward')}
                type="select"
              >
                <option value="" key="0" />
                {wards
                  ? wards.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/schedule" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ScheduleUpdate;
